import React from 'react';

const About = () => {
  return (
    <div className='card all-center'>
      <h1>About</h1>
      <p>
        <i className='fab fa-react'></i> GitScout  a Web app to search{' '}
        <i className='fab fa-github'></i> Github profiles
      </p>
      <p>
        Made by Ajay Shitkar @2023
      </p>
    </div>
  );
};

export default About;
